import outlookBWLogo from '@/components/PlatformIcon/icons/outlook-bw.png';
import outlookLogo from '@/components/PlatformIcon/icons/outlook.png';
import { PlatformTypes } from '@/types/gql.generated';
import { useAlwaysAvailable } from './availability.lib';
import type { DestinationModule } from './types';

// The weblink flavor of Outlook. While the Outlook integration is available it
// stands in for this destination in the pickers (see
// outlookIntegration.destination.ts standsInFor).
export const outlookLinkDestination: DestinationModule = {
  platform: PlatformTypes.OutlookLink,
  behavior: 'copy',
  name: 'Outlook',
  addLabel: 'Add to Outlook',
  syncKind: 'copy',
  icon: { kind: 'image', src: outlookLogo, bwSrc: outlookBWLogo },
  isPinnable: true,
  persistedByServer: false,
  statusSource: 'localOnly',
  useIsAvailable: useAlwaysAvailable,
  weblink: { urlKey: 'outlook' },
};
